import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const ViewAssetItem = ({ formData }) => {
  const data = {
    ahu_unique_id: "",
    filter_type: "",
    filter_manufacturer: "",
    installation_date: "",
    location_type: "",
    filter_dimensions: "",
    micron_rating: "",
    cleaning_frequency_days: 0,
    cleaning_frequency_allowance_days: 0,
    max_allowed_cleanings: 0,
    last_cleaning_date: "",
    valid_operational_life_days: 0,
    current_status: "",
    availability_status: "",
    ...formData,
  };

  return (
    <>
      <style>{`
        @media (max-width: 576px) {
          #offcanvasRightViewFilterAsset {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightViewFilterAsset {
            width: 55% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightViewFilterAsset {
            width: 45% !important;
          }
        }
        @media (min-width: 1441px) {
          #offcanvasRightViewFilterAsset {
            width: 30% !important;
          }
        }
      `}</style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewFilterAsset"
        aria-labelledby="offcanvasRightViewFilterAssetLabel"
      >
        <div className="offcanvas-header d-flex justify-content-between align-items-center">
          <h4 id="offcanvasRightViewFilterAssetLabel">View Filter</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>

        <hr className="m-0" />

        <div className="offcanvas-body">
          <ul
            className="nav nav-tabs nav-tabs-bottom"
            id="viewFilterTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <Link
                className="nav-link active"
                data-bs-toggle="tab"
                data-bs-target="#view-filter"
                role="tab"
              >
                AHU
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link
                className="nav-link"
                data-bs-toggle="tab"
                data-bs-target="#view-additional"
                role="tab"
              >
                Filter
              </Link>
            </li>
          </ul>

          <div className="tab-content pt-3">
            {/* Filter Details Tab */}
            <div
              className="tab-pane fade show active"
              id="view-filter"
              role="tabpanel"
            >
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">AHU Unique ID</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.ahu_unique_id}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Filter Type/Category</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.filter_type}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Filter Manufacturer</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.filter_manufacturer}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Date of Installation</label>
                  <input
                    type="date"
                    className="form-control"
                    value={data.installation_date}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">AHU Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.location_type}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Filter Dimensions</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.filter_dimensions}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Micron Rating (µm)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.micron_rating}
                    readOnly
                  />
                </div>
              </div>
            </div>

            {/* Additional Details Tab */}
            <div className="tab-pane fade" id="view-additional" role="tabpanel">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Cleaning Frequency</label>
                  <div className="input-group">
                    <input
                      type="number"
                      className="form-control"
                      value={data.cleaning_frequency_days}
                      readOnly
                    />
                    <span className="input-group-text">Days</span>
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Frequency Allowance</label>
                  <div className="input-group">
                    <input
                      type="number"
                      className="form-control"
                      value={data.cleaning_frequency_allowance_days}
                      readOnly
                    />
                    <span className="input-group-text">Days</span>
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Cleaning Limit</label>
                  <input
                    type="number"
                    className="form-control"
                    value={data.max_allowed_cleanings}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Last Cleaning </label>

                  <input
                    type="date"
                    className="form-control"
                    value={data.last_cleaning_date}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label" title="Valid Operational Life">
                    Valid Op. Life{" "}
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      className="form-control"
                      value={data.valid_operational_life_days}
                      readOnly
                    />

                    <span className="input-group-text">Days</span>
                  </div>
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Current Status</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.current_status}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Availability Status</label>
                  <input
                    type="text"
                    className="form-control"
                    value={data.availability_status}
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Label</label>
                  <input
                    type="text"
                    className="form-control"
                    name="Label"
                    // value={formState.label}
                    // onChange={handleChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mt-3">
            {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="offcanvas">
              Close
            </button> */}
          </div>
        </div>
      </div>
    </>
  );
};

ViewAssetItem.propTypes = {
  formData: PropTypes.shape({
    ahu_unique_id: PropTypes.string,
    filter_type: PropTypes.string,
    filter_manufacturer: PropTypes.string,
    installation_date: PropTypes.string,
    location_type: PropTypes.string,
    filter_dimensions: PropTypes.string,
    micron_rating: PropTypes.string,
    cleaning_frequency_days: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    cleaning_frequency_allowance_days: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    max_allowed_cleanings: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    last_cleaning_date: PropTypes.string,
    valid_operational_life_days: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    current_status: PropTypes.string,
    availability_status: PropTypes.string,
  }),
};

ViewAssetItem.defaultProps = {
  formData: {},
};

export default ViewAssetItem;
